function FilledFavoriteIcon(props) {
    return (
        <svg
            width={18}
            height={18}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0V0z" />
                <path
                    d="M6.784 3c-1.51 0-2.75.55-3.566 1.451C2.402 5.352 2 6.575 2 7.901c0 1.242.643 2.62 1.554 4.042.912 1.421 2.113 2.877 3.31 4.197a65.595 65.595 0 0 0 4.783 4.73.544.544 0 0 0 .706 0s2.39-2.09 4.783-4.73c1.197-1.32 2.398-2.776 3.31-4.197C21.357 10.52 22 9.143 22 7.9c0-1.326-.402-2.549-1.218-3.45-.816-.9-2.056-1.45-3.566-1.45C14.296 3 12.71 4.9 12 6.028 11.29 4.9 9.704 3 6.783 3zm0 .948c3.43 0 4.735 3.235 4.735 3.235A.513.513 0 0 0 12 7.49a.513.513 0 0 0 .48-.308s1.307-3.235 4.737-3.235c1.246 0 2.143.422 2.772 1.117.63.696.986 1.688.986 2.836 0 .922-.544 2.209-1.41 3.56-.868 1.352-2.04 2.777-3.214 4.072a58.792 58.792 0 0 1-4.35 4.323 58.777 58.777 0 0 1-4.352-4.323c-1.174-1.295-2.346-2.72-3.213-4.071-.867-1.352-1.41-2.639-1.41-3.561 0-1.148.356-2.14.985-2.836.63-.695 1.526-1.117 2.773-1.117z"
                    stroke={`${props.fill || '#2e2e2e'}`}
                    strokeWidth={0.2}
                    fill={`${props.fill || '#2e2e2e'}`}
                    fillRule="nonzero"
                />
                <path
                    d="M6.784 3.948c3.43 0 4.735 3.235 4.735 3.235A.513.513 0 0 0 12 7.49a.513.513 0 0 0 .48-.308s1.307-3.235 4.737-3.235c1.246 0 2.143.422 2.772 1.117.63.696.986 1.688.986 2.836 0 .922-.544 2.209-1.41 3.56-.868 1.352-2.04 2.777-3.214 4.072a58.792 58.792 0 0 1-4.35 4.323 58.777 58.777 0 0 1-4.352-4.323c-1.174-1.295-2.346-2.72-3.213-4.071-.867-1.352-1.41-2.639-1.41-3.561 0-1.148.356-2.14.985-2.836.63-.695 1.526-1.117 2.773-1.117z"
                    fill={`${props.fill || '#2e2e2e'}`}
                />
            </g>
        </svg>
    );
}

export default FilledFavoriteIcon;
